import type { Theme } from "@mui/material";
import { use } from "react";

import { ModalActionContext } from "./modal-action-context";

export type ModalActionContextType =
  | { handleConfirmAction: () => Promise<void>; closeModal: () => void }
  | undefined;

export function useModalAction() {
  const context = use(ModalActionContext);
  if (context === undefined) {
    throw new Error("useModalAction must be used within a ModalActionContext provider");
  }
  return context;
}

/** Same context as {@link useModalAction} but returns `undefined` when there is no provider (e.g. uploads on a plain form). */
export function useOptionalModalAction(): ModalActionContextType {
  return use(ModalActionContext);
}

export const MODAL_DEFAULTS = {
  confirmText: "Créer le compte",
  cancelText: "Annuler",
} as const;

export const DEFAULT_MODAL_STYLES = {
  dialogTitleSx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    pr: 1,
  },
  closeButtonSx: (theme: Theme) => ({
    ml: 2,
    color: theme.palette.grey[500],
    position: "absolute",
    right: 8,
    top: 8,
  }),
  dialogActionsSx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
    pr: 2,
    pl: 2,
  },
} as const;
